<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import { onMounted, onUnmounted, watch } from 'vue'
import { useStore } from 'vuex'
import { useInactivityTimeout } from '@/composables/useInactivityTimeout'

export default {
  name: 'App',
  setup() {
    const store = useStore()
    const { startTracking, stopTracking, resetTimers } = useInactivityTimeout()
    
    onMounted(() => {
      // Démarrer le suivi d'inactivité si l'utilisateur est connecté
      if (store.getters['auth/isAuthenticated']) {
        startTracking()
      }
    })
    
    // Surveiller les changements d'authentification
    watch(
      () => store.getters['auth/isAuthenticated'],
      (isAuthenticated) => {
        if (isAuthenticated) {
          // Démarrer le suivi quand l'utilisateur se connecte
          startTracking()
        } else {
          // Arrêter le suivi quand l'utilisateur se déconnecte
          stopTracking()
        }
      }
    )
    
    onUnmounted(() => {
      stopTracking()
    })
    
    return {}
  }
}
</script>

<style>
/* Global styles are imported in main.js */
</style>
